import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { View, TouchableOpacity, ViewStyle, StyleProp } from 'react-native';
import { MenuTrigger, renderers, MenuOptions, Menu } from 'react-native-popup-menu';
import { screenMargin, smallestFontSize, smallestMargin } from '_utils/sizes';
import { Icon } from 'Components';
import HeimeText from './HeimeText';
import { useThemeContext } from '../_utils/themeContext';

const Explainer = ({
    explainer,
    accessibilityLabel,
    triggerStyle,
}: {
    explainer: string;
    accessibilityLabel: string;
    triggerStyle: StyleProp<ViewStyle>;
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const onToggle = () => setIsOpen((prev) => !prev);
    const { t } = useTranslation();
    const { theme } = useThemeContext();

    return (
        <Menu
            renderer={renderers.Popover}
            rendererProps={{
                placement: 'auto',
                preferredPlacement: 'top',
                anchorStyle: { backgroundColor: theme.main },
            }}
            opened={isOpen}
            onBackdropPress={onToggle}
        >
            <MenuTrigger onPress={onToggle}>
                <TouchableOpacity
                    style={triggerStyle}
                    onPress={onToggle}
                    accessibilityLabel={accessibilityLabel}
                    hitSlop={16}
                >
                    <Icon name="question" color="main" />
                </TouchableOpacity>
            </MenuTrigger>
            <MenuOptions
                customStyles={{
                    optionsContainer: {
                        backgroundColor: theme.main,
                        borderRadius: screenMargin,
                        padding: smallestMargin,
                    },
                }}
            >
                <View style={{ flexDirection: 'row' }}>
                    <HeimeText
                        style={{
                            fontSize: smallestFontSize,
                            lineHeight: smallestFontSize * 1.5,
                            color: theme.white,
                            flexShrink: 1,
                        }}
                        maxFontSizeMultiplier={4}
                    >
                        {explainer}
                    </HeimeText>
                    <TouchableOpacity
                        accessibilityLabel={t('global:close')}
                        onPress={onToggle}
                        style={{ marginLeft: 'auto', marginTop: -smallestMargin }}
                    >
                        <Icon name="cross" color="white" scale={0.6} />
                    </TouchableOpacity>
                </View>
            </MenuOptions>
        </Menu>
    );
};

export default Explainer;
